__webpack_require__.p = "/anniversary-website/";